import React, { createContext, useContext } from 'react';
import { useUnreadNudges } from './useUnreadNudges.js';
import { sendNudge } from './api.js';
import { NUDGE_AUTO_FETCH } from '../../config/Config.js';

const NudgeContext = createContext();

export const NudgeProvider = ({ 
  children, 
  autoFetch = NUDGE_AUTO_FETCH 
}) => {
  const {
    nudges,
    loading,
    error,
    currentNudge,
    refresh,
    markRead,
    nextNudge,
  } = useUnreadNudges({ autoFetch });
  
  // Wrap sendNudge to handle errors consistently
  const sendNudgeWithErrorHandling = async (recipientId, text) => {
    try {
      return await sendNudge(recipientId, text);
    } catch (err) {
      throw new Error(err instanceof Error ? err.message : 'Failed to send nudge');
    }
  };
  
  const value = {
    nudges,
    loading,
    error,
    currentNudge,
    refresh,
    markRead,
    sendNudge: sendNudgeWithErrorHandling,
    nextNudge,
  };
  
  return (
    <NudgeContext.Provider value={value}>
      {children}
    </NudgeContext.Provider>
  );
};

export const useNudges = () => {
  const context = useContext(NudgeContext);
  if (context === undefined) {
    throw new Error('useNudges must be used within a NudgeProvider');
  }
  return context;
};
